import { ActionType, PayloadErrorType } from '../../types/reduxTypes';
import { Author, Upload, UploadItem, UploadItemFilterParams } from 'types/uploadType';
import {
  DELETE_UPLOAD,
  DELETE_UPLOAD_FAILED,
  DELETE_UPLOAD_SUCCESS,
  EDIT_UPLOAD_ITEM,
  EDIT_UPLOAD_ITEM_FAILED,
  EDIT_UPLOAD_ITEM_SUCCESS,
  FIND_AUTHORS,
  FIND_AUTHORS_FAILED,
  FIND_AUTHORS_SUCCESS,
  GET_UPLOADS,
  GET_UPLOADS_FAILED,
  GET_UPLOADS_SUCCESS,
  GET_UPLOAD_CATALOG,
  POST_UPLOAD,
  POST_UPLOAD_FAILED,
  POST_UPLOAD_SUCCESS,
  PUBLISH_UPLOAD_ITEM,
  PUBLISH_UPLOAD_ITEM_FAILED,
  PUBLISH_UPLOAD_ITEM_SUCCESS,
  PUT_UPLOAD_ITEM,
  PUT_UPLOAD_ITEM_FAILED,
  PUT_UPLOAD_ITEM_SUCCESS,
  SET_LOADING_CATALOGS,
  STOP_EDIT_UPLOAD_ITEM,
  SWITCH_UPLOAD_LIST_FILTER,
  SWITCH_UPLOAD_LIST_FILTER_FAILED,
  SWITCH_UPLOAD_LIST_FILTER_SUCCESS,
} from '../constants';
import { DeleteItemPayload, GetClsItemsPayload, SwitchUploadListFilterPayload } from './profileActions';
import { UploadFile } from 'features/NktFileUploader/types';
import { UploadListFilter } from 'types/stateTypes';

export type GetUploadsPayload = {
  isAppend: boolean;
  isPublished?: boolean;
  page: number;
  pageSize?: number;
  filterParams?: UploadItemFilterParams;
};

export type GetUploadsSuccessPayload = {
  data: Upload[];
  isAppend: boolean;
};

export type PutUploadItemPayload = {
  uploadItem: UploadItem;
  filesToRemove: UploadFile[];
};

export function editUploadItem(payload: UploadItem): ActionType<UploadItem> {
  return {
    payload,
    type: EDIT_UPLOAD_ITEM,
  };
}

export function editUploadItemSuccess(payload: UploadItem): ActionType<UploadItem> {
  return {
    payload,
    type: EDIT_UPLOAD_ITEM_SUCCESS,
  };
}

export function editUploadItemFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: EDIT_UPLOAD_ITEM_FAILED,
  };
}

export function stopEditUploadItem(): ActionType {
  return {
    payload: null,
    type: STOP_EDIT_UPLOAD_ITEM,
  };
}

export function getUploads(payload: GetUploadsPayload): ActionType<GetUploadsPayload> {
  return {
    payload,
    type: GET_UPLOADS,
  };
}

export function getUploadsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: GET_UPLOADS_FAILED,
  };
}

export function getUploadsSuccess(payload: GetUploadsSuccessPayload): ActionType<GetUploadsSuccessPayload> {
  return {
    payload,
    type: GET_UPLOADS_SUCCESS,
  };
}

export function postUpload(payload: Upload): ActionType<Upload> {
  return {
    payload,
    type: POST_UPLOAD,
  };
}

export function postUploadFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: POST_UPLOAD_FAILED,
  };
}

export function postUploadSuccess(payload: Upload): ActionType<Upload> {
  return {
    payload,
    type: POST_UPLOAD_SUCCESS,
  };
}

export function deleteUpload(payload: DeleteItemPayload): ActionType<DeleteItemPayload> {
  return {
    payload,
    type: DELETE_UPLOAD,
  };
}

export function deleteUploadFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: DELETE_UPLOAD_FAILED,
  };
}

export function deleteUploadSuccess(payload: string): ActionType<string> {
  return {
    payload,
    type: DELETE_UPLOAD_SUCCESS,
  };
}

export function putUploadItem(payload: PutUploadItemPayload): ActionType<PutUploadItemPayload> {
  return {
    payload,
    type: PUT_UPLOAD_ITEM,
  };
}

export function putUploadItemFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: PUT_UPLOAD_ITEM_FAILED,
  };
}

export function putUploadItemSuccess(payload: UploadItem): ActionType<UploadItem> {
  return {
    payload,
    type: PUT_UPLOAD_ITEM_SUCCESS,
  };
}

export function getUploadCatalog(payload: GetClsItemsPayload): ActionType<GetClsItemsPayload> {
  return {
    payload,
    type: GET_UPLOAD_CATALOG,
  };
}

export function setLoadingCatalogs(payload: boolean): ActionType<boolean> {
  return {
    payload,
    type: SET_LOADING_CATALOGS,
  };
}

export function findAuthors(payload: string): ActionType<string> {
  return {
    payload,
    type: FIND_AUTHORS,
  };
}

export function findAuthorsFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: FIND_AUTHORS_FAILED,
  };
}

export function findAuthorsSuccess(payload: Author[]): ActionType<Author[]> {
  return {
    payload,
    type: FIND_AUTHORS_SUCCESS,
  };
}

export function switchUploadListFilter(
  payload: SwitchUploadListFilterPayload
): ActionType<SwitchUploadListFilterPayload> {
  return {
    payload,
    type: SWITCH_UPLOAD_LIST_FILTER,
  };
}

export function switchUploadListFilterFailed(payload: PayloadErrorType): ActionType<PayloadErrorType> {
  return {
    payload,
    type: SWITCH_UPLOAD_LIST_FILTER_FAILED,
  };
}

export function switchUploadListFilterSuccess(payload: UploadListFilter): ActionType<UploadListFilter> {
  return {
    payload,
    type: SWITCH_UPLOAD_LIST_FILTER_SUCCESS,
  };
}

export function publishUploadItem(payload: string): ActionType<string> {
  return {
    payload,
    type: PUBLISH_UPLOAD_ITEM,
  };
}

export function publishUploadItemFailed(payload: UploadItem): ActionType<UploadItem> {
  return {
    payload,
    type: PUBLISH_UPLOAD_ITEM_FAILED,
  };
}

export function publishUploadItemSuccess(payload: unknown): ActionType<unknown> {
  return {
    payload,
    type: PUBLISH_UPLOAD_ITEM_SUCCESS,
  };
}
